export const retry = (
  fn: () => Promise<void>,
  delay: number,
): Promise<void> => new Promise((resolve) => {
  fn()
    .then(resolve)
    .catch(() => {
      setTimeout(() => {
        retry(fn, delay).then(resolve);
      }, delay);
    });
});
